import { type ReactNode } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/utils/cn';
import { type Toast } from './toast';

const STYLES: Record<string, string> = {
  success: 'border-success/30 text-success',
  error: 'border-error/30 text-error',
  info: 'border-info/30 text-info',
};

function ToastItem({
  t,
  onDismiss,
}: {
  t: Toast;
  onDismiss: () => void;
}): ReactNode {
  return (
    <div
      className={cn(
        'flex items-center gap-sm rounded-md border bg-surface px-md py-sm text-xs shadow-md',
        STYLES[t.type]
      )}
    >
      <span className="flex-1">{t.message}</span>
      <button
        onClick={onDismiss}
        className="text-text-tertiary hover:text-text-primary"
        aria-label="Dismiss"
      >
        <X size={12} />
      </button>
    </div>
  );
}

export function ToastList({
  toasts,
  onDismiss,
}: {
  toasts: Toast[];
  onDismiss: (id: number) => void;
}): ReactNode {
  return (
    <div className="fixed bottom-4 right-4 z-[60] space-y-2">
      {toasts.map((t) => (
        <ToastItem key={t.id} t={t} onDismiss={() => onDismiss(t.id)} />
      ))}
    </div>
  );
}
